<template>
  <VendorPublisherListView provider-type="publisher" />
</template>

<script>
import VendorPublisherListView from '@/reusable/vendor-publisher-list-view/VendorPublisherListView'

export default {
  components: {
    VendorPublisherListView
  }
}
</script>
